import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LiveChat from "../components/LiveChat";
import '../App.css';
import GetQuoteButton from "../components/GetQuoteButton";
import QAChatbot from "../components/QAChatBot";
// import "./SparesStoreSupply.css"; // External CSS if needed
import BackToTopButton from "../components/BackToTopButton";
import ScrollSocialIcons from "../components/ScrollSocialIcons";


const Spares = () => {
  return (
    <div className="sector-detail">
      <Navbar />
      <header className="sparesstore-hero">
        <h1>Spares & Store Supply</h1>
        <p>
         We specialize in providing high-quality spare parts and essential store supplies for vessels, ensuring uninterrupted 
         operations. Our global sourcing network guarantees fast and efficient delivery, at destination port or next port call.
        </p>
      </header>
      <div className="sector-content">
        <h3 className="offer-title">What We Offer:</h3>
        <p>We ensure the availability of critical spares and ship stores to meet all your operational requirements, delivered promptly and Globally.</p>
        <ul className="offer-list">
          <li>
            <span className="offer-icon"></span>
            Engine, Deck and Electrical spare parts
          </li>
          <li>
            <span className="offer-icon"></span>
            Provisions and bonded stores supply
          </li>
          <li>
            <span className="offer-icon"></span>
            Customize sourcing
          </li>
          <li>
            <span className="offer-icon"></span>
            Delivery coordination at ports and offshore
          </li>
          <li>
            <span className="offer-icon"></span>
            Certified marine equipment’s and accessories
          </li>
        </ul>
      </div>
      <LiveChat />
      <QAChatbot/>
      <ScrollSocialIcons/>
      <GetQuoteButton/>
      <BackToTopButton/>
      <Footer />
    </div>
  );
};

export default Spares;
